import LocalDate from './utils.js';

export default function MarqueeValues({ jackpots }) {
  const jp = jackpots.map(({ at, amount }, index) => {
    const dateTime = new LocalDate(at);

    return (
      <li key={index} className="mb-0 d-flex gap-2 align-items-center text-primary">
        <span className="marquee__price h4 mb-0">${amount.toLocaleString()}</span>
        <span className="fs-lg text-uppercase">Jackpot</span>
        <time className="marquee__time label-3 text-gray-subtle" dateTime={at}>{dateTime.formattedTime()}</time>
      </li>
    );
  });

  return (
    <>
      <ul className="mb-0">{jp}</ul>
      <ul className="mb-0 hidden">{jp}</ul>
      <ul className="mb-0 hidden">{jp}</ul>
    </>
  );
}
